import { motion } from "framer-motion";
import { NeuralBackground } from "./NeuralBackground";

export function CTA() {
  return (
    <section className="relative py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass grain scanlines relative overflow-hidden rounded-3xl px-6 py-20 text-center"
        >
          <span className="aurora -top-24 left-1/4 h-72 w-72" style={{ opacity: 0.3 }} />
          <NeuralBackground />
          <div className="relative">
            <h2 className="text-3xl font-semibold tracking-tight text-balance sm:text-5xl">
              Stop Guessing. <span className="text-gold-gradient">Start Briefing.</span>
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm text-muted-foreground sm:text-base">
              Every position arrives with entry, invalidation, targets and the reasoning behind it.
            </p>
            <a
              href="#terminal"
              className="mt-9 inline-block rounded-xl px-8 py-3.5 text-sm font-semibold tracking-wide text-primary-foreground uppercase transition-transform hover:-translate-y-0.5"
              style={{ backgroundImage: "var(--gradient-gold)" }}
            >
              Open AI Terminal
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer className="border-t border-border/60 py-12">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 lg:grid-cols-[minmax(0,1fr)_auto] lg:px-8">
        <div className="min-w-0">
          <p className="text-sm font-semibold tracking-[0.18em] uppercase">
            Daddy <span className="text-gold-gradient">Of AI</span>
          </p>
          <p className="mt-2 flex items-center gap-2 text-xs text-muted-foreground">
            <span className="live-dot" /> Phase 2 · Live Decision Engine
          </p>
          <p className="mt-4 max-w-md text-xs leading-relaxed text-muted-foreground">
            Disclaimer: Trading involves substantial risk. Historical accuracy figures describe past
            decision-log performance and are not a promise of future results.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3 text-xs tracking-[0.16em] text-muted-foreground uppercase">
          <a href="#performance" className="hover:text-primary">
            Dashboard
          </a>
          <a href="#engines" className="hover:text-primary">
            Engines
          </a>
          <a href="#terminal" className="hover:text-primary">
            Docs
          </a>
          <a href="#news" className="hover:text-primary">
            Disclaimer
          </a>
        </nav>
      </div>
    </footer>
  );
}
